export default import.meta.ROLLDOWN_FILE_URL_D72rlr0lQGIV8_jgzqQhcA